import React, { useState, useEffect } from "react";
import ParentHeader from "../../Parent/ParentHeader/ParentHeader";
import { useLocation } from "react-router-dom";
import RegisteredGrade from "./RegisteredGrade";
import Loader from "../../Components/Loader/Loader";
import "./style.css";
import { serviceConsumer } from "../../network/ServiceConsumer";
import RegisterTitle from "./Components/RegisterTitle";
import { sortGrades } from "../../helper/SortSyllabus";
import { getIsTeacher } from "../../helper/getIsTeacher";
import { useDispatch, useSelector } from "react-redux";
import { setConversionRate, updateGradePrices } from "./helper";

const RegisterGradeEvents = () => {
  const [allDancer, setAllDancer] = useState([]);
  const [loading, setLoading] = useState(false);
  const [listofData, setListofData] = useState([]);
  const [showPaymentPage, setshowPaymentPage] = useState(false);
  const [client, setClient] = useState("");
  const [errors, seterros] = useState("");
  const [grades, setGrades] = useState([]);
  const [checkedStateNew, setCheckedStateNew] = useState([]);
  const [dancerError, SetDancerError] = useState({ id: 0, message: "" });
  const [selectedGrades, setSelectedGrades] = useState([]);
  const [eventDetails, setEventDetails] = useState();
  const [initialLoading, setInitialLoading] = useState(false);

  // const params = useParams();
  // const eventId = params?.id
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const eventId = searchParams.get("id");
  const dispatch = useDispatch();
  const currencyDetails = useSelector((state) => state.currencyReducer);

  // back button navigation based on 3 select, payment and error UI
  const backToViewEvent = () => {
    window.history.go(-1);
  };

  const backToRegisterGradeEventFromErrorPage = () => {
    setshowPaymentPage(false);
    seterros("");
  };

  //  to get eventDetails
  const getEventDetails = async () => {
    setInitialLoading(true);
    try {
      if (eventId) {
        const url = `${process.env.REACT_APP_BASE_URL}/grade-exam/${eventId}`;
        const response = await serviceConsumer("GET", url);
        setConversionRate(dispatch, response.grade_exams.usdExchangeRate);
        setEventDetails(response.grade_exams);
        localStorage.setItem(
          "exchangeCurrency",
          response.grade_exams?.exchangeCurrency
        );
      }
      setInitialLoading(false);
    } catch (error) {
      setInitialLoading(false);
    }
  };

  //navigating back to homepage if the url is misused
  useEffect(() => {
    getEventDetails();
    getAllDancers();
    getIsTeacher(setLoading);
    document.title = "Feis.Link - Register Dancers";
  }, []);

  useEffect(() => {
    getAllGrades();
  }, [currencyDetails]);

  const getAllGrades = async () => {
    const url = `${process.env.REACT_APP_BASE_URL}/grade-exam/fees/${eventId}`;
    setInitialLoading(true);
    try {
      const response = await serviceConsumer("GET", url);
      if (response?.grade_exam_fees) {
        const updatedGradePrice = updateGradePrices(
          response?.grade_exam_fees,
          currencyDetails
        );
        setGrades(sortGrades(updatedGradePrice));
      }
      setInitialLoading(false);
    } catch (error) {
      setInitialLoading(false);
    }
  };

  //get dancer list from api call
  const getAllDancers = async () => {
    const url = `${process.env.REACT_APP_BASE_URL}/account/dancers`;
    setInitialLoading(true);
    try {
      const response = await serviceConsumer("GET", url);
      setAllDancer(response.dancers);
      setInitialLoading(false);
    } catch (error) {
      setInitialLoading(false);
    }
  };

  //setting grades and checked state size of 2d array
  useEffect(() => {
    setListofData(
      Array.from({ length: allDancer.length }, () =>
        Array.from({ length: grades.length }, () => false)
      )
    );
  }, [grades.length, allDancer.length]);

  //checkbox and grade array handler
  const handleOnChange = async (index, dancer, grade) => {
    setLoading(true);
    const item = selectedGrades[index]?.grades?.find(
      (it) => it._id === grade._id
    );
    const dancer_name = `${dancer.fname} ${dancer.lname}`;

    if (selectedGrades[index] && item) {
      removeGrade(index, dancer_name, dancer._id, grade._id);
    } else {
      const newSelectedList = [...selectedGrades];
      const gradesList = newSelectedList[index]?.grades?.length
        ? [...newSelectedList[index]?.grades, grade]
        : [grade];
      const dancerTotal = gradesList.reduce(
        (res, { grade_fee }) => res + grade_fee,
        0
      );
      const values = {
        grades: gradesList,
        dancer_id: dancer._id,
        dancerTotal,
        dancer_name: `${dancer.fname} ${dancer.lname}`,
      };

      newSelectedList[index] = values;

      setSelectedGrades(newSelectedList);

      const newList = [...checkedStateNew];
      const checkedStateNewItem = newList[index]
        ? [...newList[index], grade._id]
        : [grade._id];
      newList[index] = checkedStateNewItem;
      setCheckedStateNew(newList);
    }

    setTimeout(() => {
      setLoading(false);
    }, 300);
  };

  const removeGrade = (index, dancer_name, dancer_id, gradeId) => {
    const newList = [...checkedStateNew];
    const checkedStateNewItem = newList[index]?.filter(
      (item) => item !== gradeId
    );
    newList[index] = checkedStateNewItem;
    setCheckedStateNew(newList);

    const newSelectedList = [...selectedGrades];
    const grades = selectedGrades[index]?.grades?.filter(
      (item) => item._id !== gradeId
    );
    const dancerTotal = grades.reduce(
      (res, { grade_fee }) => res + grade_fee,
      0
    );

    const values = { grades, dancer_id, dancer_name, dancerTotal };

    newSelectedList[index] = values;

    setSelectedGrades(newSelectedList);
  };

  //condition to display payment page
  const setshowPaymentPageHandler = (val) => {
    setLoading(true);
    setshowPaymentPage(val);
  };

  const errormsg = (err) => {
    setshowPaymentPage(false);
    seterros(err);
    setLoading(false);
  };

  //client secret from stripe
  const clientSecret = (secret) => {
    setClient(secret);
    setLoading(false);
  };

  return (
    <div>
      <ParentHeader />
      {loading && <Loader />}
      {initialLoading && <Loader />}
      {!initialLoading && (
        <div className="parent-register row">
          <div className="col-md-7 leftDiv">
            {/* select UI  */}
            {!showPaymentPage && !errors && (
              <>
                <RegisterTitle
                  eventDetails={eventDetails}
                  onClick={backToViewEvent}
                />
                <hr className="mt-0" />
                <div className="col-md-8 offset-md-2 offset-1 col-10 reg-left-container">
                  {allDancer?.map((dancer, index) => {
                    return (
                      <div key={dancer._id} className="my-5">
                        <h5>
                          Register dancer:&nbsp;
                          <span style={{ color: "#68ad3f" }}>
                            {dancer?.fname} {dancer?.lname}
                          </span>
                        </h5>
                        <hr className="mt-0"></hr>
                        <h6
                          style={{
                            color: "#68ad3f",
                            marginTop: "10px",
                            fontSize: "12px",
                          }}
                        >
                          Choose Grade
                        </h6>
                        <div
                          style={{
                            border: "2px solid #EAEAEA",
                            padding: "5px",
                            width: "fit-content",
                          }}
                          className="chosegradee"
                        >
                          {grades?.map((grade) => (
                            <div
                              className="btn-group btn-group-toggle action"
                              data-toggle="buttons"
                              style={{ margin: "5px" }}
                              key={grade._id}
                            >
                              <label
                                className={
                                  checkedStateNew &&
                                  checkedStateNew[index]?.includes(grade._id)
                                    ? "btn activeBtn"
                                    : "btn"
                                }
                              >
                                <input
                                  type="checkbox"
                                  checked={
                                    checkedStateNew &&
                                    checkedStateNew[index]?.includes(grade._id)
                                      ? true
                                      : false
                                  }
                                  onChange={() =>
                                    handleOnChange(index, dancer, grade)
                                  }
                                />
                                {grade?.grade_name}
                              </label>{" "}
                            </div>
                          ))}
                        </div>
                        {dancer._id === dancerError.id && (
                          <p className="error">{dancerError.message}</p>
                        )}
                      </div>
                    );
                  })}
                </div>
              </>
            )}
            {/* error page UI */}
            {errors && (
              <>
                <RegisterTitle
                  eventDetails={eventDetails}
                  onClick={backToRegisterGradeEventFromErrorPage}
                />
                <hr className="mt-0 " />
                <div className="col-md-8 offset-md-2 offset-1 col-10 reg-left-container">
                  <center>
                    {" "}
                    <div style={{ color: "red" }}>{errors}</div>
                  </center>
                </div>
              </>
            )}
          </div>
          <div className="col-md-5 d-flex flex-column right-calc-div">
            <RegisteredGrade
              eventDetails={eventDetails}
              selectedGrades={selectedGrades}
              removeGrade={removeGrade}
              setshowPaymentPage={setshowPaymentPageHandler}
              clientSecret={clientSecret}
              errormsg={errormsg}
              showPaymentPage={showPaymentPage}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default RegisterGradeEvents;
